import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material';
import { tokens } from '../../theme';
import { Button, TextField, MenuItem, Select, FormControl, InputLabel, Box, Grid } from '@mui/material';

const EditInfluencer = ({ influencer, onClose }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [formData, setFormData] = useState({
    IGHandle: '',
    IGLink: '',
    Contact: '',
    Followers: '',
    AvgViews: '',
    Segment: '',
    Category: '',
    Location: '',
    Gender: '',
    EngRate: '',
    Language: '',
  });

  useEffect(() => {
    if (influencer) {
      setFormData({
        IGHandle: influencer.IGHandle || '',
        IGLink: influencer.IGLink || '',
        Contact: influencer.Contact || '',
        Followers: influencer.Followers || '',
        AvgViews: influencer.AvgViews || '',
        Segment: influencer.Segment || '',
        Category: influencer.Category || '',
        Location: influencer.Location || '',
        Gender: influencer.Gender || '',
        EngRate: influencer.EngRate || '',
        Language: influencer.Language || '',
      });
    }
  }, [influencer]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const API_URL = `https://api.dmaverix.com/api/v2/influencers/${influencer.id}`;
    const JWT_TOKEN = localStorage.getItem('token');

    if (!JWT_TOKEN) {
      console.error('No token found.');
      return;
    }

    try {
      const response = await fetch(API_URL, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${JWT_TOKEN}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (response.ok && data.success) {
        alert('Influencer updated successfully!');
        onClose();
      } else {
        alert('Error updating influencer: ' + data.message);
      }
    } catch (error) {
      console.error('Error updating influencer:', error);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Instagram Handle"
            variant="outlined"
            fullWidth
            margin="normal"
            name="IGHandle"
            value={formData.IGHandle}
            onChange={handleInputChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Instagram Link"
            variant="outlined"
            fullWidth
            margin="normal"
            name="IGLink"
            value={formData.IGLink}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Contact"
            variant="outlined"
            fullWidth
            margin="normal"
            name="Contact"
            value={formData.Contact}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Followers"
            variant="outlined"
            fullWidth
            margin="normal"
            name="Followers"
            type="number"
            value={formData.Followers}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Avg Views"
            variant="outlined"
            fullWidth
            margin="normal"
            name="AvgViews"
            type="number"
            value={formData.AvgViews}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth margin="normal" required>
            <InputLabel>Segment</InputLabel>
            <Select
              name="Segment"
              value={formData.Segment}
              onChange={handleInputChange}
              label="Segment"
            >
              <MenuItem value="Comedy">Comedy</MenuItem>
              <MenuItem value="Drama">Drama</MenuItem>
              <MenuItem value="Lifestyle">Lifestyle</MenuItem>
              <MenuItem value="Fitness">Fitness</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth margin="normal" required>
            <InputLabel>Category</InputLabel>
            <Select
              name="Category"
              value={formData.Category}
              onChange={handleInputChange}
              label="Category"
            >
              <MenuItem value="Micro">Micro</MenuItem>
              <MenuItem value="Macro">Macro</MenuItem>
              <MenuItem value="Nano">Nano</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Location"
            variant="outlined"
            fullWidth
            margin="normal"
            name="Location"
            value={formData.Location}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth margin="normal" required>
            <InputLabel>Gender</InputLabel>
            <Select
              name="Gender"
              value={formData.Gender}
              onChange={handleInputChange}
              label="Gender"
            >
              <MenuItem value="Male">Male</MenuItem>
              <MenuItem value="Female">Female</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Engagement Rate"
            variant="outlined"
            fullWidth
            margin="normal"
            name="EngRate"
            value={formData.EngRate}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Language"
            variant="outlined"
            fullWidth
            margin="normal"
            name="Language"
            value={formData.Language}
            onChange={handleInputChange}
          />
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px', fontFamily:'Inter' }}>
        <Button onClick={onClose} sx={{ marginRight: 2 , fontFamily:'Inter', fontWeight:'600', backgroundColor: theme.palette.mode === 'dark' ? '#b5adad' : '#f44b4b',color: theme.palette.mode === 'dark' ? '#fff' : '#000',}}>
          Cancel
        </Button>
        <Button type="submit" variant="contained" color="primary" style={{fontFamily:'Inter',fontWeight:'600', backgroundColor: theme.palette.mode === 'dark' ? '#4cceac' : '#4cceac',color: theme.palette.mode === 'dark' ? '#fff' : '#000',}}>
          Save Changes
        </Button>
      </Box>
    </Box>
  );
};

export default EditInfluencer;

